export default __webpack_public_path__ + "static/media/icon__external-link.364060d8.svg";